var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/consents/HipaaConsent.tsx";
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { VStack } from '@adc/parallax-component-library';
import { useApiError } from 'Hooks';
import { Button, Footer, Header, LogoActionBar, Main, RichText, ScrollContainer, Spinner } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { getAuthSession } from 'Utilities/session';
import { updateConsent } from 'Services/consent';
const mapStateToProps = ({
  env: {
    app
  },
  register: {
    patientId
  }
}) => {
  return {
    app,
    patientId
  };
};
const connector = connect(mapStateToProps);
const HipaaConsent = ({
  app,
  patientId
}) => {
  const [loading, setLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const handleSubmitHipaaAction = useCallback(async action => {
    try {
      setLoading(true);
      const authSession = getAuthSession();
      if (authSession) {
        await updateConsent(patientId, action, app, 'hipaa', authSession.accessToken);
        mediator.publish('router:navigate', '/rwe');
        return;
      }
      showApiErrorModal();
    } catch {
      showApiErrorModal();
    } finally {
      setLoading(false);
    }
  }, [app, patientId, showApiErrorModal]);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    titleTestID: "Hipaa.actionTitle",
    title: i18n.t('Hipaa.title'),
    noActionButton: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    titleTestID: "Hipaa.title",
    title: i18n.t('Hipaa.title'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(RichText, {
    text: i18n.t('Hipaa.content.hipaaRichText.bodyText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    customProps: /*#__PURE__*/React.createElement(VStack, {
      padding: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onPress: () => handleSubmitHipaaAction('accept'),
      testID: "Hipaa.accept",
      label: i18n.t('Global.microcopy.common.accept'),
      "aria-label": i18n.t('Global.microcopy.common.accept'),
      marginBottom: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(Button, {
      onPress: () => handleSubmitHipaaAction('decline'),
      variant: "tertiary",
      testID: "Hipaa.decline",
      label: i18n.t('Global.microcopy.common.decline'),
      "aria-label": i18n.t('Global.microcopy.common.decline'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 91,
        columnNumber: 13
      }
    })),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 7
    }
  }));
};
export default connector(HipaaConsent);